/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

interface ChartWrapperProps {
  children: React.ReactNode;
  hasTabs?: boolean;
}

const ChartWrapper = ({ children, hasTabs = true }: ChartWrapperProps) => {
  const PADDING_TOP = "24px";
  const TAB_HEIGHT = "36px";

  const wrapperHeight = hasTabs
    ? `calc(100% - ${PADDING_TOP} - ${TAB_HEIGHT})`
    : "100%";

  return (
    <div
      css={css({
        // calculate height of a card content
        height: wrapperHeight,

        ...(hasTabs && { paddingTop: PADDING_TOP })
      })}
    >
      {children}
    </div>
  );
};

export default ChartWrapper;
